module.exports = __webpack_public_path__ + "img/tilstand_fysisk_kjemiske_kvalitetselement.28435582.jpg";